import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

import Button from 'devextreme-react/button';
import TreeList, { Column, Lookup, Selection } from 'devextreme-react/tree-list';

import { AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { CheckBox } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { useGetContractorObjectLocationsQuery } from 'bus/contractorObject/services';
import { TemplateSalaryItem } from 'bus/templateSalary/types';

import EditAddress from '../../modals/add-address';
import DeleteModal from '../../modals/delete';
import EditModal from '../../modals/edit-add';

const templateSalaryDataStore = $createStore('/v1/templateSalary', 'id');

type Props = {
  onChangeSelect: (data: any) => void;
  idFromTaskForm?: number | null;
};

const ContractorObject: FC<Props> = (props) => {
  let { id } = useParams<{ id: string }>();

  if (props.idFromTaskForm) {
    id = String(props.idFromTaskForm);
  }

  const dataObjects: any = useMemo(() => {
    if (id) return $createStore(`/v1/ContractorObject/${id}`, 'id');
  }, [id]);

  const dataObjectsTypes: any = useMemo(() => {
    if (id) return $createStore('/v1/ContractorObject/types/', 'id');
  }, [id]);

  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();

  const [visibleModalDelete, setVisibleModalDelete] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);
  const [seleryItems, setSeleryItems] = useState<TemplateSalaryItem[]>([]);

  const refGrid = useRef<TreeList | null>(null);

  const onSelectionChanged = useCallback(
    (e: any) => {
      if (e.selectedRowsData && e.selectedRowsData.length && e.selectedRowsData[0].type !== 2) {
        props.onChangeSelect(e.selectedRowsData[0]);
      } else {
        props.onChangeSelect(null);
      }
    },
    [props],
  );

  const refresh = useCallback(() => refGrid.current?.instance.refresh(), []);

  useEffect(() => {
    //@ts-ignore
    templateSalaryDataStore.load().then((res) => setSeleryItems(res));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="">
      <div className="pr-2 pt-1">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanEditObject']}>
            <EditModal
              id={null}
              parentId={null}
              addRoot={true}
              refresh={refresh}
              contractorIdTaskForm={id}
              templateSalary={seleryItems}
            />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>

      <DeleteModal
        visible={visibleModalDelete}
        changeVisible={(show) => setVisibleModalDelete(show)}
        id={openId}
        refresh={refresh}
      />

      <TreeList
        dataSource={dataObjects}
        showBorders={true}
        columnAutoWidth={true}
        focusedRowEnabled={true}
        wordWrapEnabled={true}
        keyExpr="id"
        parentIdExpr="parentId"
        onSelectionChanged={onSelectionChanged}
        ref={refGrid}
      >
        <Selection mode="single" />
        {/* <Column dataField="id" /> */}
        {/* <Column dataField="parentId" /> */}
        <Column dataField="objectType" caption="Тип" visible={false}>
          <Lookup dataSource={dataObjectsTypes} valueExpr="id" displayExpr="name" />
        </Column>
        <Column dataField="address" caption="Адрес" />
        <Column
          dataField="fault"
          caption="Оплата запчастей"
          cellRender={(data) => <span>{data.data.parentId === null ? data.data.fault : ''}</span>}
        />
        <Column dataField="location" caption="Местность">
          <Lookup dataSource={contractorObjectLocations} valueExpr="id" displayExpr="name" />
        </Column>

        <Column
          dataField="actions"
          caption=""
          cellRender={(data) => {
            return (
              <ClaimsProvider claimsBlock={['CanEditObject']}>
                <div className="d-flex">
                  {data.data.parentId === null ? (
                    <>
                      <EditAddress
                        id={null}
                        parentId={data.key}
                        refresh={refresh}
                        type="add"
                        contractorIdTaskForm={id}
                      />
                      <EditModal
                        id={data.key}
                        parentId={data.data.parentId}
                        refresh={refresh}
                        contractorIdTaskForm={id}
                        templateSalary={seleryItems}
                      />
                    </>
                  ) : (
                    <EditAddress
                      id={data.key}
                      parentId={data.data.parentId}
                      refresh={refresh}
                      type="edit"
                      contractorIdTaskForm={id}
                    />
                  )}
                  <Button
                    icon="trash"
                    type="normal"
                    stylingMode="text"
                    onClick={() => {
                      setOpenId(data.key);
                      setVisibleModalDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            );
          }}
        />
      </TreeList>
    </div>
  );
};

export default ContractorObject;
